export default class NodeTree {
  children = new Array();
  constructor(node = {}) {
    this.id = node.id ? node.id : 0;
    this.text = node.data.text ? node.data.text : 0;
    this.setChildren(node.children);
  }

  setChildren(children = new Array()) {
    children.forEach((n) => this.children.push(new NodeTree(n)));
  }
}
